import { StatusBadge } from "@/components/vroom/status-badge";
import { LineRow, toStatusKind } from "./line-row.tsx";
import { SummaryRows, fmtMinutes } from "./summary-rows.tsx";
import type { HoursEntriesAdminWeekResponse } from "@/api/generated/types.gen";

type Group = HoursEntriesAdminWeekResponse["groups"][number];
type Related = HoursEntriesAdminWeekResponse["meta"]["related"];

interface GroupRowProps {
  group: Group;
  weekDates: string[];
  related: Related;
  selected: boolean;
  onSelect: () => void;
}

export function GroupRow({ group, weekDates, related, selected, onSelect }: GroupRowProps) {
  const isExported = group.status === "exported";
  const rowClass = `cursor-pointer ${selected ? "bg-p-50 shadow-[inset_3px_0_0_var(--p-600)]" : "hover:bg-ink-50/30"} ${isExported ? "opacity-55" : ""}`;
  return (
    <>
      <tr className={rowClass} onClick={onSelect}>
        <td className="pl-3 py-2 align-top">
          <StatusBadge status={toStatusKind(group.status)} />
        </td>
        <td className="py-2 align-top font-semibold">
          {group.kind === "worker"
            ? group.worker.name
            : `${group.workorder.number}${group.crane ? ` × ${group.crane.number}` : ""}`}
        </td>
        <td className="py-2 align-top">
          {group.kind === "workorder-crane" && group.workorder.city ? group.workorder.city : ""}
        </td>
        <td className="py-2 align-top"></td>
        <td className="py-2 align-top"></td>
        {weekDates.map((_, i) => (
          <td key={i} className="py-2"></td>
        ))}
        <td className="py-2 text-right pr-3 font-semibold tabular-nums">
          {fmtMinutes(group.summary.totalMinutes)}
        </td>
      </tr>
      {group.status === "rejected" && group.rejectComment && (
        <tr className="bg-vroom-red-soft/20 text-xs">
          <td colSpan={13} className="px-6 py-1.5 text-vroom-red">
            <strong>Afgewezen:</strong> {group.rejectComment}
          </td>
        </tr>
      )}
      {group.lines.map((line) => (
        <LineRow
          key={`${line.workerId}|${line.workorderId ?? "none"}|${line.craneId ?? "none"}`}
          line={line}
          weekDates={weekDates}
          workorders={related.workorders}
          cranes={related.cranes}
          groupKind={group.kind}
          groupKey={{
            workerName:
              group.kind === "workorder-crane"
                ? related.users.find((u) => u.id === line.workerId)?.name
                : undefined,
            workerId: line.workerId,
          }}
        />
      ))}
      <SummaryRows
        pauzeduurPerDay={group.summary.pauzeduurPerDay}
        buckets={group.summary.buckets}
        below8hDays={group.summary.below8hDays}
      />
      <tr className="h-3">
        <td colSpan={13}></td>
      </tr>
    </>
  );
}
